<div role="region" aria-label="Bottom buttons" #buttonContainer>
    <ng-content></ng-content>
</div>
